// extracted by mini-css-extract-plugin
export default {"codeblock":"CodeBlock_codeblock__hzqQv"};